/*
 * ブランド判定と body クラス付与。
 *
 * 流れ:
 *   1. URL クエリ or localStorage から client_id を取得
 *   2. BRAND_MAPPING で同期的にブランドを解決
 *   3. 成功: body.classList に brand を付与（halmekUp は既定のためクラス付与なし）、document.title を更新
 *   4. 失敗: /error?reason=unknown_client へリダイレクト
 *
 * 同期で完結するので FOUC は発生しない。/clients API も呼ばない。
 *
 * 他ルート（/dashboard, /settings 等）でも呼ばれる想定。
 * client_id が無い場合は body から halmekEvents を外すのみ（クラス残留防止）。
 */

import { getBrandByClientId, getSiteTitleByBrand } from '../brandMapping';

function resolveClientId() {
	// URL や localStorage の値に半角スペース等が混入していると client_id が解決できず
	// /error にループするので必ず trim する。
	const qs = new URLSearchParams(window.location.search);
	const fromQuery = qs.get('client_id')?.trim();
	const fromStorage = localStorage.getItem('client-id')?.trim();
	return fromQuery || fromStorage || null;
}

// 現在の URL/localStorage に対応する brand を同期取得（React 側のレンダリング用）
export function getCurrentBrand() {
	return getBrandByClientId(resolveClientId());
}

function applyBodyClass(brand) {
	// 常にいったん外してから付け直す（初回 load 時は client_id 未確定でスキップされ、後から localStorage が入るケースに対応）
	document.body.classList.remove('halmekEvents');
	if (brand === 'halmekEvents') {
		document.body.classList.add('halmekEvents');
	}
	document.title = getSiteTitleByBrand(brand);
}

function redirectToError(reason) {
	window.location.href = `/error?reason=${encodeURIComponent(reason)}`;
}

export function applyBrand() {
	// /error 上では brand 解決の意味が無く、解決失敗時の redirect 先が /error 自身のため
	// loop を引き起こす。エラーページでは早期 return する。
	if (window.location.pathname === '/error') {
		return;
	}

	const clientId = resolveClientId();
	if (!clientId) {
		// client_id が無いときは body の events クラスを外す（他ルートで client 任意のときの残留防止）
		applyBodyClass(null);
		return;
	}

	const brand = getBrandByClientId(clientId);
	if (!brand) {
		redirectToError('unknown_client');
		return;
	}

	applyBodyClass(brand);
}
